import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { doGet, doPut } from 'utils';

import { Form } from '../Form';

function EditCivilFinish() {
  const { finishId } = useParams();
  const [state, setState] = useState({
    name: '',
    alias: '',
    finishId: null,
    disabled: false,
  });

  async function fetchFromApi() {
    doGet({
      url: `finish/civil/${finishId}`,
    })
      .then(({ data: { title, alias } }) => {
        setState({
          ...state,
          name: title,
          alias: alias.join('\n'),
          disabled: false,
        });
      })
      .catch(err => {
        console.error(err);
      });
  }

  useEffect(() => {
    fetchFromApi();
  }, []);

  const onChange = {
    updateForm: e => {
      const { id, value } = e.target;
      setState({ ...state, [id]: value });
    },
  };

  const onSubmit = {
    update: () => {
      const { name, alias } = state;
      const isFormInComplete = !name || !alias;
      if (isFormInComplete) {
        return;
      }
      setState({ ...state, disabled: true });
      doPut({
        url: `finish/civil/${finishId}`,
        body: {
          name,
          alias: alias.split('\n').map(item => item.trim()),
        },
      })
        .then(() => fetchFromApi())
        .catch(() => {
          console.error('Something failed, please try again later');
        });
    },
  };

  const { name, alias, disabled } = state;
  const caption = disabled ? 'Saving...' : 'Save';
  return (
    <>
      <Form
        name={name}
        caption={caption}
        alias={alias}
        onChange={onChange.updateForm}
        onSubmit={onSubmit.update}
      />
    </>
  );
}

export { EditCivilFinish };
